module.exports = __webpack_public_path__ + "static/media/sWhitehouse.177c6ed5.jpeg";